/**
 * Confetti Animation for Add to Cart Success
 * Creates a confetti explosion effect when products are added to cart
 */

// Check if ConfettiAnimation is already defined to prevent redeclaration
if (typeof window.ConfettiAnimation === 'undefined') {
  class ConfettiAnimation {
    constructor() {
      this.colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#f0932b', '#eb4d4b', '#6c5ce7', '#a29bfe'];
      this.confettiContainer = null;
      this.isAnimating = false;
    }

  // Create confetti container
  createContainer() {
    if (this.confettiContainer) return this.confettiContainer;
    
    this.confettiContainer = document.createElement('div');
    this.confettiContainer.id = 'confetti-container';
    this.confettiContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: 9999;
      overflow: hidden;
    `;
    document.body.appendChild(this.confettiContainer);
    return this.confettiContainer;
  }

  // Create individual confetti piece
  createConfettiPiece(startX, startY) {
    const confetti = document.createElement('div');
    const size = Math.random() * 10 + 5;
    const color = this.colors[Math.floor(Math.random() * this.colors.length)];
    const rotation = Math.random() * 360;
    const velocityX = (Math.random() - 0.5) * 10;
    const velocityY = Math.random() * -15 - 10;
    const gravity = 0.5;
    const drag = 0.99;
    
    confetti.style.cssText = `
      position: absolute;
      width: ${size}px;
      height: ${size}px;
      background: ${color};
      left: ${startX}px;
      top: ${startY}px;
      transform: rotate(${rotation}deg);
      border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
      pointer-events: none;
    `;

    return {
      element: confetti,
      x: startX,
      y: startY,
      vx: velocityX,
      vy: velocityY,
      gravity: gravity,
      drag: drag,
      life: 1.0,
      decay: 0.015
    };
  }

  // Animate confetti pieces
  animateConfetti(pieces) {
    const container = this.createContainer();
    
    pieces.forEach(piece => {
      container.appendChild(piece.element);
    });

    const animate = () => {
      let activePieces = 0;

      pieces.forEach(piece => {
        if (piece.life <= 0) {
          if (piece.element.parentNode) {
            piece.element.remove();
          }
          return;
        }

        activePieces++;

        // Update physics
        piece.vy += piece.gravity;
        piece.vx *= piece.drag;
        piece.vy *= piece.drag;
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.life -= piece.decay;

        // Update position and opacity
        piece.element.style.left = piece.x + 'px';
        piece.element.style.top = piece.y + 'px';
        piece.element.style.opacity = piece.life;
        piece.element.style.transform = `rotate(${piece.x * 2}deg)`;
      });

      if (activePieces > 0) {
        requestAnimationFrame(animate);
      } else {
        this.isAnimating = false;
        // Clean up container
        if (container.parentNode) {
          container.remove();
        }
        this.confettiContainer = null;
      }
    };

    animate();
  }

  // Main confetti explosion function
  explode(targetElement = null) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    let startX, startY;

    if (targetElement) {
      // Get position of target element (like add to cart button)
      const rect = targetElement.getBoundingClientRect();
      startX = rect.left + rect.width / 2;
      startY = rect.top + rect.height / 2;
    } else {
      // Default to center of screen
      startX = window.innerWidth / 2;
      startY = window.innerHeight / 2;
    }

    // Create confetti pieces
    const pieces = [];
    const numPieces = 50;

    for (let i = 0; i < numPieces; i++) {
      const offsetX = (Math.random() - 0.5) * 100;
      const offsetY = (Math.random() - 0.5) * 50;
      pieces.push(this.createConfettiPiece(startX + offsetX, startY + offsetY));
    }

    this.animateConfetti(pieces);
  }

  // Quick burst effect for smaller celebrations
  burst(targetElement = null) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    let startX, startY;

    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      startX = rect.left + rect.width / 2;
      startY = rect.top + rect.height / 2;
    } else {
      startX = window.innerWidth / 2;
      startY = window.innerHeight / 2;
    }

    // Create fewer, faster pieces for burst effect
    const pieces = [];
    const numPieces = 25;

    for (let i = 0; i < numPieces; i++) {
      const piece = this.createConfettiPiece(startX, startY);
      // Make burst pieces faster and more spread out
      piece.vx = (Math.random() - 0.5) * 20;
      piece.vy = Math.random() * -20 - 5;
      piece.decay = 0.02; // Faster decay for quick burst
      pieces.push(piece);
    }

    this.animateConfetti(pieces);
  }
}

// Create global instance
window.confetti = new ConfettiAnimation();
}

// Auto-integrate with add to cart buttons
document.addEventListener('DOMContentLoaded', function() {
  console.log('Confetti animation loaded and ready!'); // Debug log
  
  // Listen for successful cart additions
  document.addEventListener('cart:updated', function(event) {
    console.log('Cart updated event detected!'); // Debug log
    // Trigger confetti when cart is updated
    if (event.detail && event.detail.trigger) {
      window.confetti.burst(event.detail.trigger);
    } else {
      window.confetti.burst();
    }
  });

  // Direct click handler for add-to-cart buttons
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.add-to-cart-btn, [type="submit"][name="add"], .btn--add-to-cart');
    
    if (button) {
      console.log('Add to cart button clicked!', button); // Debug log
      
      // If button has data-confetti attribute, trigger immediately
      if (button.hasAttribute('data-confetti')) {
        // Trigger confetti after a short delay
        setTimeout(() => {
          console.log('Triggering confetti!'); // Debug log
          window.confetti.burst(button);
        }, 200);
      }
      
      // Also set up form submission listener
      const form = button.closest('form');
      if (form) {
        form.addEventListener('submit', function(submitEvent) {
          console.log('Form submission detected!'); // Debug log
          // Delay confetti slightly to ensure cart update happens first
          setTimeout(() => {
            if (!submitEvent.defaultPrevented) {
              console.log('Triggering confetti after form submit!'); // Debug log
              window.confetti.burst(button);
            }
          }, 300);
        }, { once: true }); // Only listen once
      }
    }
  });
});

// Utility functions for manual triggering
window.triggerConfetti = function(element) {
  window.confetti.explode(element);
};

window.triggerConfettiBurst = function(element) {
  window.confetti.burst(element);
};